import { createStore } from 'vuex'
import createVuexPersistedState from 'vuex-persistedstate';
import { LOCAL_STORAGE_KEY } from '@/utils/const';
import { persistedStateStorage } from '@/utils/support_session';
import account from './modules/account';
import activityLog from './modules/activity_log';
import organization from './modules/organization';
import error from './modules/error';
import template from './modules/template';
import donation from './modules/donation';
import folder from './modules/folder';
import screen from './modules/screen';
import announcement from './modules/announcement';
import shiureiTorah from './modules/shiurei_torah';
import shiureiTorahTemplate from './modules/shiurei_torah_template';
import sidenav from './modules/sidenav';
import member from './modules/member';
import minyanim from './modules/minyanim';
import minyanimType from './modules/minyanim_type';
import room from './modules/room';
import zmanim from './modules/zmanim';
import ticket from './modules/ticket';
import ticketComment from './modules/ticket_comment';
import dateTimeBanner from './modules/date_time_banner';
import screenArtboard from './modules/screen_artboard';
import poster from './modules/poster';
import apiKey from './modules/api_key';
import customFont from './modules/custom_font';
import minyanimCountdown from './modules/minyanim_countdown';
import minyanRoll_N from './modules/minyan_roll_N';
import minyan_N from './modules/minyan_N';
import zmanim_N from './modules/zmanim_N';
import zmanimDisplayOverride_N from './modules/zmanim_display_override_N';
import kabbalah_N from './modules/kabbalah_N';
import kabbalahDesign_N from './modules/kabbalah_design_N';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    account,
    activityLog,
    announcement,
    shiureiTorah,
    shiureiTorahTemplate,
    apiKey,
    customFont,
    dateTimeBanner,
    donation,
    folder,
    error,
    kabbalah_N,
    kabbalahDesign_N,
    member,
    minyanim,
    minyanimCountdown,
    minyanimType,
    minyan_N,
    minyanRoll_N,
    organization,
    zmanim_N,
    zmanimDisplayOverride_N,
    poster,
    room,
    screen,
    screenArtboard,
    sidenav,
    ticket,
    ticketComment,
    template,
    zmanim
  },
  plugins: [
    createVuexPersistedState({
      key: LOCAL_STORAGE_KEY,
      // This frame's own storage during a support session (utils/support_session).
      storage: persistedStateStorage(LOCAL_STORAGE_KEY),
      paths: ['account'],
    }),
  ],
})
